import AttendanceDetailsChangedHistoryIcon from '@material-ui/icons/ViewList';

import AttendanceDetailsChangedHistoryList from './AttendanceDetailsChangedHistoryList';

export default {
  list: AttendanceDetailsChangedHistoryList,
  icon: AttendanceDetailsChangedHistoryIcon,
};
